import { NgModule } from "@angular/core";
import { RouterModule, Routes } from "@angular/router";
import { SaysoAnalyticsGuard } from "../shared/guards/saysoAnalyticsGuard.guard";
import { TopicResolver } from "../shared/resolvers/topic-resolver.resolver";

const routes: Routes = [
  {
    path: "",
    children: [
      {
        path: "settings",
        loadChildren: () =>
          import("./saysoSettings/saysoSettings.module").then(m => m.SaysoSettingsModule),
        data: { title: "sayso" }
      },
      {
        path: "installation",
        loadChildren: () =>
          import("./saysoSettings/installation/sayso-installation.module").then(
            m => m.SaysoInstallationModule
          ),
        data: { title: "sayso Installation" }
      },
      {
        path: "add",
        loadChildren: () =>
          import("./saysoSettings/topicAdd/topic-add.module").then(m => m.TopicAddModule),
        data: { title: "Add Topic" }
      },
      {
        path: "edit",
        resolve: { topic: TopicResolver },
        runGuardsAndResolvers: "always",
        loadChildren: () =>
          import("./saysoSettings/topicEdit/topic-edit.module").then(m => m.TopicEditModule),
        data: { title: "Edit Topic", mode: "edit" }
      },
      {
        path: "duplicate",
        loadChildren: () =>
          import("./saysoSettings/topicEdit/topic-edit.module").then(m => m.TopicEditModule),
        resolve: { topic: TopicResolver },
        runGuardsAndResolvers: "always",
        data: { title: "Duplicate Topic", mode: "duplicate" }
      },
      {
        path: "view",
        resolve: { topic: TopicResolver },
        runGuardsAndResolvers: "always",
        loadChildren: () =>
          import("./saysoSettings/topicView/topic-view.module").then(m => m.TopicViewModule),
        data: { title: "View Topic" }
      },
      {
        path: "dashboard",
        canActivate: [SaysoAnalyticsGuard],
        loadChildren: () => import("./charting/charting.module").then(m => m.ChartingModule),
        data: { title: "sayso dashboard" }
      },
      {
        path: "org-call-history",
        loadChildren: () =>
          import("./orgCallHistory/org-call-history.module").then(m => m.OrgCallHistoryModule),
        data: { title: "Call History" }
      },
      {
        path: "team-page",
        loadChildren: () =>
          import("./teamPageSettings/teamPageSettings.module").then(m => m.TeamPageSettingsModule),
        data: { title: "Team Page" }
      },
      {
        path: "manager-dashboard",
        loadChildren: () =>
          import("./managerDashboard/manager-dashboard.module").then(m => m.ManagerDashboardModule),
        data: { title: "Sayso Dashboard" }
      }
    ]
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  declarations: []
})
export class SaysoRoutingModule {}
